var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "14",
        "height": "14",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M13.402 12.22H1.182a.6.6 0 000 1.197h12.22a.6.6 0 000-1.198zm-9.206-1.797c.08 0 .164-.017.248-.05h.005l3.404-1.601.035-.018 5.79-5.799a1.043 1.043 0 000-1.48L12.508.305a1.046 1.046 0 00-1.48.002l-5.767 5.77-.026.026-.016.033-1.592 3.388a.62.62 0 00.038.607.64.64 0 00.53.292zm6.876-8.47l.694-.694.958.958-.694.695-.958-.959zM5.38 8.61l.849-1.808L10.226 2.8l.958.958L7.185 7.76l-1.806.85z",
        "fill": "#FFF",
        "fill-rule": "evenodd"
      }
    })]));
  }
};